__turbopack_context__.v({
  "section": "styles-module-scss-module__can92G__section",
});
